import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import ThemeToggle from "./themeToggle";

import "./styles/navBar.css";

const NavBar = (props) => {
	const { active } = props;
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	const toggleMobileMenu = () => {
		setMobileMenuOpen(!mobileMenuOpen);
	};

	const menuItems = [
		{ label: "Profile", path: "/", key: "home" },
		{ label: "About", path: "/about", key: "about" },
		{ label: "Projects", path: "/projects", key: "projects" },
		{ label: "Blog", path: "/blog", key: "blog" },
		{
			label: "Public Speaking",
			path: "/publicspeaking",
			key: "publicspeaking",
		},
	];

	return (
		<React.Fragment>
			{/* Desktop Navigation */}
			<div className="nav-container">
				<nav className="navbar">
					<div className="nav-background">
						<ul className="nav-list">
							{menuItems.map((item) => (
								<li
									key={item.key}
									className={
										active === item.key
											? "nav-item active"
											: "nav-item"
									}
								>
									<Link to={item.path}>{item.label}</Link>
								</li>
							))}
						</ul>
					</div>
				</nav>
			</div>

			{/* Mobile Navigation */}
			<div className="mobile-nav-container">
				<button
					className="mobile-menu-button"
					onClick={toggleMobileMenu}
					aria-label="Toggle menu"
					title="Toggle menu"
				>
					<FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} />
				</button>
			</div>

			{/* Mobile Menu */}
			{mobileMenuOpen && (
				<div className="mobile-menu">
					<ul className="mobile-menu-list">
						{menuItems.map((item) => (
							<li
								key={item.key}
								className={
									active === item.key
										? "mobile-menu-item active"
										: "mobile-menu-item"
								}
								onClick={() => setMobileMenuOpen(false)}
							>
								<Link to={item.path}>{item.label}</Link>
							</li>
						))}
					</ul>
					<div className="mobile-menu-theme-toggle">
						<ThemeToggle />
					</div>
				</div>
			)}
		</React.Fragment>
	);
};

export default NavBar;
